import { Injectable } from '@angular/core';
import { IAddress } from 'src/app/shared/services/address.service';
import { HttpClient } from '@angular/common/http';
import { AuthService } from 'src/app/auth/services/auth.service';
import { Observable } from 'rxjs';
import { SettingService } from 'src/app/shared/services/setting.service';
import { PageService } from 'src/app/services/page.service';
import { finalize, map } from 'rxjs/operators';
import { AlertService } from 'src/app/shared/services/alert.service';
import { ILegacyAddress } from './account.service';
import { ApiControllerService } from 'src/app/shared/services/api-controller.service';

export interface ISaveCreditCardRequest {
  storeId: string;
  cardNumber: number;
  cvn: number;
  paymentCardTypeId: number;
  preferredName?: string;
  expirationYear: number;
  expirationMonth: number;
  cardHolderName: string;
  address: IAddress;
}

export interface ICreditCard {
  Id: string;
  Cvn?: number;
  MerchantId?: string;
  GhostedText: string;
  Archived: boolean;
  PaymentCardTypeId: number;
  PreferredName?: string;
  ExpirationYear: number;
  ExpirationMonth: number;
  CardHolderName: string;
  Address: ILegacyAddress;

  PaymentCardTypeEnumText?: any;
}

export interface ICreditCardDisplay {
  id: string;
  cvn?: number;
  merchantId?: string;
  ghostedText: string;
  archived: boolean;
  paymentCardTypeId: number;
  preferredName?: string;
  expirationYear: number;
  expirationMonth: number;
  cardHolderName: string;
  address: ILegacyAddress;
}

export interface ISaveCreditCard {
  CardNumber: string;
  Cvn: number;
  PaymentCardTypeId: number;
  CardHolderName: string;
  ExpirationYear: number;
  ExpirationMonth: number;
  Address: IAddress;
}

export interface ISaveCreditCardResponse {
  id: string;
  preferredName?: string;
  cardNumber: string;
  cvn: number;
  paymentCardTypeId: number;
  cardHolderName: string;
  expirationYear: number;
  expirationMonth: number;
  address: IAddress;
}

export interface ICreditCardCvc {
  Card: ICreditCard;
  Cvc?: number;
}

export interface IListSavedCreditCardRequest {
  storeId?: string;
  includeArchived?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class CreditCardService {
  constructor(private http: HttpClient,
    private auth: AuthService,
    private page: PageService,
    private setting: SettingService,
    private alert: AlertService,
    private apiController: ApiControllerService) {

  }

  getSavedCard(model: IListSavedCreditCardRequest): Observable<ICreditCard[]> {
    return Observable.create(o => {
      let headers = this.auth.getAuthHeadersBaseObject();
      this.page.appendAuthorizationHeader(headers);

      let url = this.setting.apiUrl('Member/ListCreditCards');

      /* this.http.post<ICreditCardDisplay[]>(url, model, {
        headers: headers
      })
        .pipe(finalize(() => {
          o.complete();
        }))
        .pipe(map((savedCards) => {
          let list : ICreditCard[] = [];
          for (let savedCard of savedCards) {
            list.push({
              Id: savedCard.id,
              Address: savedCard.address,
              Archived: savedCard.archived,
              CardHolderName: savedCard.cardHolderName,
              ExpirationMonth: savedCard.expirationMonth,
              ExpirationYear: savedCard.expirationYear,
              GhostedText: savedCard.ghostedText,
              PaymentCardTypeId: savedCard.paymentCardTypeId,
              Cvn: savedCard.cvn,
              MerchantId: savedCard.merchantId,
              PreferredName: savedCard.preferredName
            })
          }
          return list;
        }))
        .subscribe(
          savedCards => {
            o.next(savedCards);
          },
          response => {
            if (response.status === 500)
              this.alert.showUnexpectedErrorMsg();

            o.error(response);
          }
        ); */

        this.apiController.post<ICreditCardDisplay[]>(url, model, {
          headers: headers
        })
          .pipe(finalize(() => {
            o.complete();
          }))
          .pipe(map((savedCards) => {
            let list : ICreditCard[] = [];
            for (let savedCard of savedCards) {
              list.push({
                Id: savedCard.id,
                Address: savedCard.address,
                Archived: savedCard.archived,
                CardHolderName: savedCard.cardHolderName,
                ExpirationMonth: savedCard.expirationMonth,
                ExpirationYear: savedCard.expirationYear,
                GhostedText: savedCard.ghostedText,
                PaymentCardTypeId: savedCard.paymentCardTypeId,
                Cvn: savedCard.cvn,
                MerchantId: savedCard.merchantId,
                PreferredName: savedCard.preferredName
              })
            }
            return list;
          }))
          .subscribe(
            savedCards => {
              o.next(savedCards);
            },
            response => {
              if (response.status === 500)
                this.alert.showUnexpectedErrorMsg();

              o.error(response);
            }
          );
    });
  }

  updateCard(card: ICreditCard): Observable<boolean> {
    return Observable.create(o => {
      let headers = this.auth.getAuthHeadersBaseObject();
      this.page.appendAuthorizationHeader(headers);

      /* this.http.post(this.setting.getLegacySmaUrl('V2/SavedCard/Save'), card, {
        headers: headers,
      })
        .pipe(finalize(() => {
          o.complete();
        }))
        .subscribe(
          res => {
            o.next(res);
          },
          response => {
            if (response.status === 500)
              this.alert.showUnexpectedErrorMsg();

            o.error(response);
          }
        ); */

      this.apiController.post(this.setting.getLegacySmaUrl('V2/SavedCard/Save'), card, {
        headers: headers,
      })
        .pipe(finalize(() => {
          o.complete();
        }))
        .subscribe(
          res => {
            o.next(res);
          },
          response => {
            if (response.status === 500)
              this.alert.showUnexpectedErrorMsg();

            o.error(response);
          }
        );
    });
  }

  saveCard(card: ISaveCreditCardRequest): Observable<ISaveCreditCardResponse> {
    card.address.streetNumber = card.address.streetNumber.toString();
    return Observable.create(o => {
      let headers = this.auth.getAuthHeadersBaseObject();
      this.page.appendAuthorizationHeader(headers);

      // need program id
      /* this.http.post(this.setting.apiUrl('Member/SaveCreditCard'), card, {
        headers: headers,
      })
        .pipe(finalize(() => {
          o.complete();
        }))
        .subscribe(
          res => {
            o.next(res);
          },
          response => {
            if (response.status === 500)
              this.alert.showUnexpectedErrorMsg();
            o.error(response);
          }
        ); */

        this.apiController.post(this.setting.apiUrl('Member/SaveCreditCard'), card, {
          headers: headers,
        })
          .pipe(finalize(() => {
            o.complete();
          }))
          .subscribe(
            res => {
              o.next(res);
            },
            response => {
              if (response.status === 500)
                this.alert.showUnexpectedErrorMsg();
              o.error(response);
            }
          );
    });
  }

  archiveCard(card: ICreditCard): Observable<boolean> {
    return Observable.create(o => {
      let headers = this.auth.getAuthHeadersBaseObject();
      this.page.appendAuthorizationHeader(headers);

      /* this.http.get(this.setting.getLegacySmaUrl('V2/SavedCard/Archive'), {
        params: {
          Id: card.Id
        },
        headers: headers,
      })
        .pipe(finalize(() => {
          o.complete();
        }))
        .subscribe(
          res => {
            o.next(res);
          },
          response => {
            if (response.status === 500)
              this.alert.showUnexpectedErrorMsg();
            o.error(response);
          }); */

      this.apiController.get(this.setting.getLegacySmaUrl('V2/SavedCard/Archive'), {
        params: {
          Id: card.Id
        },
        headers: headers,
      })
        .pipe(finalize(() => {
          o.complete();
        }))
        .subscribe(
          res => {
            o.next(res);
          },
          response => {
            if (response.status === 500)
              this.alert.showUnexpectedErrorMsg();
            o.error(response);
          });
    });
  }
}